import { user } from "localStorage";
import { hasPageAccess } from "utils/pagePermissions";

// Maps a realtime notification to the in-app route that lets the user act on it.
// Shared by the notification bell dropdown and the full Notifications page so the
// two never drift apart. Returns null when a notification has no actionable screen.
export const getNotificationRoute = (notification) => {
  switch (notification.type) {
    case "wallet_topup_request":
    case "wallet_topup":
      // Top-up approval lives on the standalone Approvals page (Top-ups sub-tab).
      return "/financial/approvals?sub=topups";
    case "withdrawal":
    case "bank_account":
      return "/wallet/withdrawal";
    case "shipping_payment_approval":
      // Land directly on the standalone Approvals page (Shipping sub-tab, the default).
      return "/financial/approvals";
    case "branch_expense_approval":
      return "/financial/approvals?sub=expenses";
    case "service_charge_approval":
      return "/financial/approvals?sub=serviceCharges";
    case "whatsapp_alert":
      // Instance status/restart lives on WhatsApp Settings. Gate here rather than
      // letting PermittedRoute bounce a non-privileged user to /scan.
      return hasPageAccess(user(), "whatsappgroup") ? "/whatsappgroup" : null;
    case "package_update":
      return notification.packageId ? `/packages/${notification.packageId}` : "/packages";
    case "package_change_request":
      // Approved/rejected — sent only to the requester (backend
      // packageChangeRequestService#notifyRequesterInApp); open that request.
      if (notification.subType === "approved" || notification.subType === "rejected") {
        return hasPageAccess(user(), "packages/change-requests") && notification.requestId
          ? `/packages/change-requests?request=${notification.requestId}`
          : null;
      }
      // New request — only whoever can actually approve gets this notification in
      // the first place (see backend packageChangeRequestService#notifyApprovers),
      // so gate the click-through on that same sub-slug, not the broader parent page.
      // Approvers land on the Approvals page's "Parcel Changes" tab; fall back to
      // the standalone queue if they can't open Approvals.
      if (!hasPageAccess(user(), "packages/change-requests/approve")) return null;
      return hasPageAccess(user(), "financial/approvals")
        ? "/financial/approvals?sub=changeRequests"
        : "/packages/change-requests";
    case "stuck_parcel":
      return hasPageAccess(user(), "parcel-monitoring") ? "/parcel-monitoring" : null;
    default:
      return null;
  }
};

export default getNotificationRoute;
